module.exports = reactVendor_4d7df80752767b89ebdf;